/**
 * @generated SignedSource<<324149e964b400104594c0fa58ea6a3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AgenticWorkerResultState = "NEEDS_REVIEW" | "DONE" | "DELETED" | "%future added value";
export type DeleteAgenticWorkerResultInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteAgenticWorkerResultMutation$variables = {
  input: DeleteAgenticWorkerResultInput;
};
export type DeleteAgenticWorkerResultMutation$data = {
  readonly deleteAgenticWorkerResult: {
    readonly deleted: boolean;
    readonly result: {
      readonly id: string;
      readonly state: AgenticWorkerResultState;
      readonly hidden: boolean;
      readonly actedBy: {
        readonly fullName: string | null;
      } | null;
    } | null;
  } | null;
};
export type DeleteAgenticWorkerResultMutation = {
  variables: DeleteAgenticWorkerResultMutation$variables;
  response: DeleteAgenticWorkerResultMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteAgenticWorkerResultPayload",
    "kind": "LinkedField",
    "name": "deleteAgenticWorkerResult",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AgenticWorkerResult",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hidden",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaRunAuthor",
            "kind": "LinkedField",
            "name": "actedBy",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteAgenticWorkerResultMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteAgenticWorkerResultMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "91fb9cc084ccb3360a8499df68fc6b4a",
    "id": null,
    "metadata": {},
    "name": "DeleteAgenticWorkerResultMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteAgenticWorkerResultMutation(\n  $input: DeleteAgenticWorkerResultInput!\n) {\n  deleteAgenticWorkerResult(input: $input) {\n    deleted\n    result {\n      id\n      state\n      hidden\n      actedBy {\n        fullName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a368ddc0192c45cfdf4675ef9fb713f";

export default node;
